import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { UPGRADE_EDIT } from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import {
  allRoomTypesSelector,
  allUpgradesSelector,
  selectedHotelCurrencySelector,
} from '../../../../property/propertySlice';
import './Upgrade-VIew.scss';

const UpgradeView = (props) => {
  const { upgrade, onViewToggle, hotelId, toggleDrawer, permissions } = props;
  const [selectedUpgrade, setSelectedUpgrade] = useState(upgrade);
  const originalRoomTypes = useSelector(allRoomTypesSelector);
  const originalUpgrades = useSelector(allUpgradesSelector);
  const currency = useSelector(selectedHotelCurrencySelector);
  const [viewArray, setViewArray] = useState([]);

  useEffect(() => {
    // retreiving selected upgrade details from api
    const upgradeObj = {
      ...originalUpgrades.find((obj) => obj.id === upgrade.id),
    };
    upgradeObj['name'] = originalRoomTypes.find(
      (roomType) => roomType.id === upgradeObj.roomTypeId,
    ).name;

    const upgradeValue = upgradeObj?.upgradeType?.map((item) => {
      const room = originalRoomTypes?.find((room) => item?.upgradeType === room?.id);
      const rate = Number(item?.rate || 0);
      const percent = Number(item?.percent || 0);

      let valueLabel = '';
      if (percent > 0) {
        valueLabel = `${percent}%`;
      } else if (rate > 0) {
        valueLabel = `${currency} ${rate}`;
      }

      return {
        name: room?.name || '',
        valueLabel,
      };
    });
    setViewArray(upgradeValue || []);

    setSelectedUpgrade(upgradeObj);
  }, [hotelId, originalUpgrades]);

  const onClickEdit = (event) => {
    toggleDrawer(UPGRADE_EDIT, true, selectedUpgrade);
  };

  const renderScreen = () => {
    return (
      <div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12 mb-4'>
            <span className='page-title-secondary'>Details</span>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label'>Room type name</div>
            <div className='details-value'>{selectedUpgrade?.name}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label'>No. of Upgrades</div>
            <div className='details-value'>{selectedUpgrade?.upgradeType?.length || 0}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label mb-1'>Upgrades</div>
            {viewArray.map((item, key) => (
              <div className='details-value' key={key}>
                {item?.name}
                {item?.valueLabel ? `: ${item?.valueLabel}` : ''}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {selectedUpgrade && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          title={selectedUpgrade.name}
          createdUserId={selectedUpgrade.createdBy}
          isEditable={
            permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
        />
      )}
    </>
  );
};

export default UpgradeView;
